import admin from "../Controllers/admin";

export default function useHasPermission() {
  const roleName = String(admin?.role?.name || "").trim().toLowerCase();

  const permissions = Array.isArray(admin?.permissions)
    ? admin.permissions.map((p) => String(p).trim())
    : [];

  const hasPermission = (permission) => {
    if (!permission) return true;

    // Full access roles
    if (roleName === "super admin" || roleName === "admin") {
      return true;
    }

    return permissions.includes(String(permission).trim());
  };

  return { hasPermission };
}